export const CLOUD_INIT = {
  NONE: 'none',
  V1: 'V1',
};

export const CLOUD_INIT_SUPPORTED_FILE_TYPES = [
  {
    label: 'YAML',
    mimeTypes: ['application/x-yaml'],
    extensions: ['yaml', 'yml'],
    readOnly: false,
  },
  {
    label: 'Compressed ZIP',
    mimeTypes: ['application/zip'],
    extensions: ['zip', 'gz'],
    readOnly: true,
  },
  {
    label: 'Compressed GZIP',
    mimeTypes: ['application/gzip', 'application/x-gzip'],
    extensions: ['gz'],
    readOnly: true,
  },
  {
    label: 'Shell Script',
    mimeTypes: ['shellscript', 'application/x-sh', 'application/x-shellscript', 'text/x-shellscript', 'text/x-sh'],
    extensions: ['sh'],
    readOnly: false,
  },
];

export const CLOUD_INIT_SUPPORTED_FILE_DEFAULT = {
  label: '',
  mimeTypes: [],
  extensions: [],
  readOnly: true,
};
